import { render, staticRenderFns } from "./ReviewDecisionModal.vue?vue&type=template&id=5c5b3e70&scoped=true"
import script from "./ReviewDecisionModal.vue?vue&type=script&lang=js"
export * from "./ReviewDecisionModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewDecisionModal.vue?vue&type=style&index=0&id=5c5b3e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b3e70",
  null
  
)

export default component.exports